export const WEBLATE_COMPONENT_NAME = 'business-center/business-center-client';
